import calculationsQueries from '@/api/modules/calculationsQueries'
import { t } from '@/i18n'
import { handleApiError } from '@/utils/apiHelpers'

class CalculationsService {
    async fetchCalculations(queryString = '') {
        try {
            return await calculationsQueries.fetchCalculations(queryString)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.fetchCalculationsError'))
            throw error
        }
    }

    async createCalculation(payload) {
        try {
            return await calculationsQueries.createCalculation(payload)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.createCalculationError'))
            throw error
        }
    }

    async fetchCalculation(calculationId) {
        try {
            return await calculationsQueries.fetchCalculation(calculationId)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchCalculationError'))
            throw error
        }
    }

    async fetchCalculationProductTypes() {
        try {
            return await calculationsQueries.fetchCalculationProductTypes()
        } catch (error) {
            handleApiError(error, t('calculations.product.notifications.fetchProductTypesError'))
            throw error
        }
    }

    async fetchCalculationProductType(productTypeId) {
        try {
            return await calculationsQueries.fetchCalculationProductType(productTypeId)
        } catch (error) {
            handleApiError(error, t('calculations.product.notifications.fetchProductTypeError'))
            throw error
        }
    }

    async fetchCalculationStatuses() {
        try {
            return await calculationsQueries.fetchCalculationStatuses()
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.fetchStatusesError'))
            throw error
        }
    }

    async updateCalculation(calculation) {
        try {
            return await calculationsQueries.updateCalculation(calculation)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.updateCalculationError'))
            throw error
        }
    }

    async updateCalculationTraderMargin(payload) {
        try {
            return await calculationsQueries.updateCalculationTraderMargin(payload)
        } catch (error) {
            handleApiError(error, t('calculations.details.summary.notifications.updateTraderMarginError'))
            throw error
        }
    }

    async deleteCalculation(calculationId) {
        try {
            return await calculationsQueries.deleteCalculation(calculationId)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.deleteCalculationError'))
            throw error
        }
    }

    async copyCalculation(payload) {
        try {
            return await calculationsQueries.copyCalculation(payload)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.copyCalculationError'))
            throw error
        }
    }

    async copyCalculationImpositionParameters(payload) {
        try {
            return await calculationsQueries.copyCalculationImpositionParameters(payload)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.copyImpositionParametersError'))
            throw error
        }
    }

    async fetchCalculationValidation(calculationId) {
        try {
            return await calculationsQueries.fetchCalculationValidation(calculationId)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchCalculationValidationError'))
            throw error
        }
    }

    async fetchCalculationImpositionTask(taskId) {
        try {
            return await calculationsQueries.fetchCalculationImpositionTask(taskId)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchImpositionTaskError'))
            throw error
        }
    }

    async updateCalculationImpositionTask(task) {
        try {
            return await calculationsQueries.updateCalculationImpositionTask(task)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.updateImpositionTaskError'))
            throw error
        }
    }

    async fetchCalculationImpositionTaskPriceComponents(calculationPk) {
        try {
            return await calculationsQueries.fetchCalculationImpositionTaskPriceComponents(calculationPk)
        } catch (error) {
            handleApiError(error, t('calculations.details.summary.notifications.fetchPriceComponentsError'))
            throw error
        }
    }

    async updateCalculationImpositionTaskPriceComponents(payload) {
        try {
            return await calculationsQueries.updateCalculationImpositionTaskPriceComponents(payload)
        } catch (error) {
            handleApiError(error, t('calculations.details.summary.notifications.updatePriceComponentsError'))
            throw error
        }
    }

    async fetchCalculationImposition(impositionId) {
        try {
            return await calculationsQueries.fetchCalculationImposition(impositionId)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchImpositionError'))
            throw error
        }
    }

    async updateCalculationImposition(imposition) {
        try {
            return await calculationsQueries.updateCalculationImposition(imposition)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.updateImpositionError'))
            throw error
        }
    }

    async updateCalculationImpositionPaperConfiguration(payload) {
        try {
            return await calculationsQueries.updateCalculationImpositionPaperConfiguration(payload)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.updatePaperConfigurationError'))
            throw error
        }
    }

    async fetchCalculationPrintColours(machineId) {
        try {
            return await calculationsQueries.fetchCalculationPrintColours(machineId)
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchPrintColoursError'))
            throw error
        }
    }

    async fetchCalculationColourTemplates() {
        try {
            return await calculationsQueries.fetchCalculationColourTemplates()
        } catch (error) {
            handleApiError(error, t('calculations.details.notifications.fetchColourTemplatesError'))
            throw error
        }
    }

    async printCalculationPriceOffer(payload) {
        try {
            return await calculationsQueries.printCalculationPriceOffer(payload)
        } catch (error) {
            handleApiError(error, t('calculations.list.notifications.printPriceOfferError'))
            throw error
        }
    }

    async printCalculationReport(payload) {
        try {
            return await calculationsQueries.printCalculationReport(payload)
        } catch (error) {
            handleApiError(error, t('calculations.details.summary.notifications.printReportError'))
            throw error
        }
    }
}

export const useCalculationsService = () => new CalculationsService()
